module.exports = __webpack_public_path__ + "static/media/thumbnail-freechoicegroup2.6f7e55e3.jpg";